import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core'

import closeIcon from '../../../images/closeIcon.svg';
import logo from '../../../images/logo.png';
import smallLogo from '../../../images/smallLogo.svg';
import endOfFormation from '../../../images/endOfFormation.png';

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

import { CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"
import SkillResultCard from "../Formation/SkillResultCard"

const TopBar = ({ setViewPlanCours, viewPlanCours }) => {
  const navigate = useNavigate();
  let location = useLocation();

  return (
    <Box sx={{
      background:"transparent",
      height:["60px", "80px", "80px", "80px"],
      minHeight:["60px", "80px", "80px", "80px"],
      padding:"0px 25px",
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      gap:["10px", "20px"],
    }}>
      <Box
        sx={{
          width:["15px", "20px"],
          minWidth:["15px", "20px"],
        }}
      />
      <Box sx={{
        flex:1,
        display:"flex",
        gap:["10px", "20px"],
        justifyContent:"center",
        userSelect:"none",
        overflow:"hidden",
      }}>
        <Box
          onClick={() => {
            document.location.reload()
          }}
          sx={{
            width:["0px", "130px", "130px", "160px"],
            minWidth:["0px", "130px", "130px", "160px"],
          }}
        >
          <img
            src={logo}
            style={{width:"100%", cursor:"pointer"}}
          />
        </Box>
        <Box
          onClick={() => {
            document.location.reload()
          }}
          sx={{
            width:["23px", "0px"],
            minWidth:["23px", "0px"],
          }}
        >
          <img
            src={smallLogo}
            style={{width:"100%", cursor:"pointer"}}
          />
        </Box>
      </Box>
      <Box
        onClick={() => {
          document.location.reload()
        }}
        sx={{
          width:["15px", "20px"],
          minWidth:["15px", "20px"],
        }}
      >
        <img
          src={closeIcon}
          style={{width:"100%", cursor:"pointer"}}
        />
      </Box>
    </Box>
  )
}

const FinDeFormation = ({ actFormation, actIndex, actPlan, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu  }) => {
  const navigate = useNavigate();
  let location = useLocation();

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { getFormationResults, setActFormation, saveUserFormation } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  const [results, setResults] = useState(null)
  const [skills, setSkills] = useState([])

  useEffect(() => {
    if (isEditor !== true && onlyContent !== true && actFormation?.isDone && actFormation?.resultFin === null) {
      //on doit donc calculer les scores
      let results = getFormationResults()
      if (results?.categories) {
        let newFormation = JSON.parse(JSON.stringify(actFormation))
        newFormation.resultFin = JSON.stringify(results?.categories)

        if (results?.doneInRat === true) {
          newFormation.isDoneInRat = true
        }

        setActFormation(newFormation)
        saveUserFormation(newFormation)
      }
    }
  }, [actFormation, onlyContent])

  useEffect(() => {
    if (isEditor !== true) {
      if (actFormation?.isDone && actFormation?.resultFin) {
        let resultFin = JSON.parse(actFormation?.resultFin)
        //master or glbMaster
        let scoreToTake = 0
        if (resultFin?.glbMaster?.score !== undefined && resultFin?.glbMaster?.score !== null) {
          scoreToTake = resultFin?.glbMaster?.score
        } else if (resultFin?.master?.score !== undefined && resultFin?.master?.score !== null) {
          scoreToTake = resultFin?.master?.score
        }
        setResults({
          resultFin : resultFin,
          finalScore : scoreToTake,
        })
      } else {
        setResults(null)
      }
    }
  }, [actFormation])

  useEffect(() => {
    if (isEditor !== true) {
      if (results && actPlan && actFormation) {
        let findPlan = actPlan?.find((el) => el.id === actFormation?.id)
        if (findPlan) {
          let skills = JSON.parse(JSON.stringify(results?.resultFin))
          delete skills.master;
          delete skills.glbMaster;

          if (findPlan?.softSkillsFromContent?.length > 0) {
            findPlan?.softSkillsFromContent?.forEach((cat) => {
              if (cat && cat?.key && cat?.value === "non") {
                delete skills[cat?.key]
              }
            })
          }

          let sortSkills = Object.fromEntries(
            Object.entries(skills).sort(([,a],[,b]) => b.score-a.score)
          )

          setSkills(Object.entries(sortSkills))
        } else {
          setSkills([])
        }
      } else {
        setSkills([])
      }
    }
  }, [results, actPlan, actFormation])

  /* EDITOR ADMIN */
  const getFormationFakeResults = (formation) => {
    var categories = {master: { score: 0 }}
    categories.glbMaster = { score: 0 }

    const manageFormat = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        if (format.categorie && format.categorie !== 'master' && format.categorie !== 'glbMaster') {
          categories[format.categorie] =  { score: 50 }
        }
      }
    }

    for (var iChap in formation.chapitre) {
      for (var iPart in formation.chapitre[iChap].partie) {
        for (var n in formation.chapitre[iChap].partie[iPart].sequence) {
          var format = formation.chapitre[iChap].partie[iPart].sequence[n]
          manageFormat(format)
        }
      }
    }

    return categories
  }

  useEffect(() => {
    if (isEditor) {
      //on doit créer des fakeResults
      let fakeResults = getFormationFakeResults(actFormation)

      setResults({
        resultFin : fakeResults,
        finalScore : results?.finalScore ? results.finalScore : fakeResults?.glbMaster?.score,
      })
    }
  }, [actFormation])

  useEffect(() => {
    if (isEditor === true) {
      if (results) {
        let skills = JSON.parse(JSON.stringify(results?.resultFin))
        delete skills.master;
        delete skills.glbMaster;

        let sortSkills = Object.fromEntries(
          Object.entries(skills).sort(([,a],[,b]) => b.score-a.score)
        )

        setSkills(Object.entries(sortSkills))

      } else {
        setSkills([])
      }
    }
  }, [results, actPlan, actFormation])
  /* END EDITOR ADMIN */


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Étapes</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center"}}>
              <Box
                onClick={() => {
                  setResults({...results, finalScore:0})
                }}
                sx={{padding:"0px 5px", height:"20px", background:actFormation?.feedbackFin?.seuil > results?.finalScore ? "red" : "black", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                En dessous
              </Box>
              <Box
                onClick={() => {
                  setResults({...results, finalScore:actFormation?.feedbackFin?.seuil})
                }}
                sx={{padding:"0px 5px", height:"20px", background:actFormation?.feedbackFin?.seuil > results?.finalScore ? "black" : "red", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                Au dessus
              </Box>
            </Box>
          </Box>
          <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Seuil</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Box>
                Seuil :
              </Box>
              <Box sx={{flex:1}}>
                <input
                  value={actFormation?.feedbackFin?.seuil}
                  style={{width:"42px"}}
                  type="number"
                  onChange={(e) => {
                    let val = parseInt(e.target.value)

                    //on regarde si on était au dessus ou en dessous sur le finalScore actuel
                    if (actFormation?.feedbackFin?.seuil > results?.finalScore) {
                      setResults({...results, finalScore:0})
                    } else {
                      setResults({...results, finalScore:val})
                    }

                    let newFormation = JSON.parse(JSON.stringify(actFormation))
                    newFormation.feedbackFin.seuil = val

                    superAdminContext?.setContent(newFormation)
                    superAdminContext?.setPlayerHasChanged(true)
                  }}
                />
              </Box>
            </Box>
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}
      {!onlyContent &&
        <TopBar setViewPlanCours={setViewPlanCours} viewPlanCours={viewPlanCours}/>
      }
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        {results &&
          <Box sx={{
            //background:"red",
            width:"100%",
            maxWidth:"1200px",
            display:"flex",
            flexDirection:"column",
            alignItems:"center",
            gap:["20px", "25px", "30px", "35px"]
          }}>
            <Box sx={{
              width:["80px", "110px", "120px", "150px"],
            }}>
              <img src={endOfFormation} style={{width:"100%"}} />
            </Box>
            <EditableField
              field={actFormation?.feedbackFin?.seuil > results?.finalScore ? actFormation.feedbackFin?.fail : actFormation.feedbackFin?.succes}
              isEditor={isEditor}
              sx={{
                color:"text.black",
                fontSize:["26px", "42px", "42px", "46px"],
                textAlign:"center"
              }}
              type={actFormation?.feedbackFin?.seuil > results?.finalScore ? ["feedbackFin", "fail"] : ["feedbackFin", "succes"]}
            />
            <EditableButton
              isEditor={false}
              type="button"
              field="Dashboard"
              sx={{}}
              onClick={() => {
                if (isEditor !== true) {
                  document.location.reload()
                }
              }}
            />
            <Box sx={{
              width:"100%",
              display:"flex",
              flexDirection:"column",
              gap:["8px", "11px", "12px", "13px"],
              overflow:"hidden",
            }}>
              {skills?.map((skill, index) => {
                return (
                  <SkillResultCard
                    key={index}
                    name={skill[0]}
                    result={skill[1]?.score}
                    seuil={isEditor ? 50 : undefined}
                  />
                )
              })}
            </Box>
          </Box>
        }
      </CenterContainer>

    </Box>
  )
}


export default FinDeFormation
